var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.95833C4 7.15333 4.65333 6.5 5.45833 6.5H22.5417C23.3467 6.5 24 7.15333 24 7.95833V20.0417C24 20.4284 23.8464 20.7994 23.5729 21.0729C23.2994 21.3464 22.9284 21.5 22.5417 21.5H5.45833C5.07156 21.5 4.70063 21.3464 4.42714 21.0729C4.15365 20.7994 4 20.4284 4 20.0417V7.95833ZM5.45833 7.75C5.40308 7.75 5.35009 7.77195 5.31102 7.81102C5.27195 7.85009 5.25 7.90308 5.25 7.95833V20.0417C5.25 20.1567 5.34333 20.25 5.45833 20.25H22.5417C22.5969 20.25 22.6499 20.2281 22.689 20.189C22.7281 20.1499 22.75 20.0969 22.75 20.0417V7.95833C22.75 7.90308 22.7281 7.85009 22.689 7.81102C22.6499 7.77195 22.5969 7.75 22.5417 7.75H5.45833Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.9865V11.0131C11.5001 10.9384 11.5203 10.8651 11.5586 10.8008C11.5968 10.7366 11.6515 10.6838 11.7171 10.648C11.7828 10.6123 11.8568 10.5948 11.9315 10.5974C12.0062 10.6001 12.0788 10.6228 12.1417 10.6631L16.7883 13.649C16.8472 13.6867 16.8956 13.7386 16.9291 13.7999C16.9626 13.8612 16.9802 13.9299 16.9802 13.9998C16.9802 14.0697 16.9626 14.1384 16.9291 14.1997C16.8956 14.2611 16.8472 14.3129 16.7883 14.3506L12.1417 17.3373C12.0788 17.3777 12.0062 17.4004 11.9315 17.403C11.8568 17.4057 11.7828 17.3882 11.7171 17.3524C11.6515 17.3166 11.5968 17.2638 11.5586 17.1996C11.5203 17.1354 11.5001 17.062 11.5 16.9873V16.9865Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayicon);
export default __webpack_public_path__ + "static/media/playicon.97134dcf9938673b97f6f27dcc3ce7f5.svg";
export { ForwardRef as ReactComponent };